import React, { Component } from 'react'

import { Map, Marker, Popup, TileLayer } from 'react-leaflet'
import L from 'leaflet'
import firebase from 'firebase'
import Point from '../../Utils/Point'

import isMobile from 'ismobilejs'

import '../styles/leaflet.css'
import './styles/ContactSectionStyles.css'

const IconMap = L.icon({
    iconUrl: 'https://firebasestorage.googleapis.com/v0/b/anhilmarin2017.appspot.com/o/icons%2ForangePin.svg?alt=media&token=f0543bb8-21d9-4ff7-9a59-0113abed5801',
    iconSize: [22, 32],
    iconAnchor: [11, 32],
    popupAnchor: [0, -33],
})

const MainIconMap = L.icon({
    iconUrl: 'https://firebasestorage.googleapis.com/v0/b/anhilmarin2017.appspot.com/o/icons%2FbluePin.svg?alt=media&token=5a4b765a-160b-4959-9d9c-f467fe98ab82',
    iconSize: [22, 32],
    iconAnchor: [11, 32],
    popupAnchor: [0, -33],
})


class ContactSection extends Component {
    constructor(props) {
        super(props)

        this.state = {
            building: '',
            city: '',
            email: '',
            licence: '',
            mainPhone: '',
            office: '',
            ooo: '',
            postalcode: '',
            smallPhone: '',
            street: '',
            title: '',
            position: null,
            objects: []
        }
    }

    componentDidMount() {

        const dbRef = firebase.database().ref('sections/ContactSection')
        const objRef = firebase.database().ref('objects')

        dbRef.on('value', this.setData.bind(this))
        objRef.on('value', this.setObjData.bind(this))


    }

    setObjData(snapshot) {
        const data = snapshot.val()

        console.log(data)

        if (data) {
            const objects = []
            for (const key in data) {
                objects.push(data[key])
            }
            const requests = objects.map(object => Point.getPoint(object.address))
            Promise.all(requests).then(r => {
                const objectsWithGeo = objects.map((item, index) => {
                    return {
                        ...item,
                        geometry: r[index].geometry
                    }
                })
                this.setState({
                    objects: objectsWithGeo
                })
            })
        }
    }

    setData(snapshot) {
        const data = snapshot.val()

        if (data) {

            this.setState({
                ...data,
            })

            const query = `${data.city} ${data.street} ${data.building} `

            Point.getPoint(query)
                .then(resp => {
                    this.setState({
                        position: resp
                    })
                })
                .catch(err => {
                    console.log(err)
                })

        }
    }

    _renderObjects() {
        if (this.state.objects.length > 0) {
            return this.state.objects.map((item, i) => {
                return (
                    <Marker key={`Marker${i}`} position={item.geometry} icon={MainIconMap}>
                        <Popup className={'ObjectsPopup'}>
                            <span>
                                <span className={'PopupTitle'}>{item.title}</span><br />
                                <span className={'PopupDescr'}>{item.address}</span>
                            </span>
                        </Popup>
                    </Marker>
                )
            })
        }

        return null
    }


    render() {
        return (
            <div className="ContactSectionWrapper columns is-mobile">

                <div className="ContactSectionWrapperContentPositioner">
                    <div className="ContactSectionWrapperContent">
                        <div className="ContactSectionTitleWrapper columns is-mobile">
                            <h2 className="column ">{this.state.title}</h2>
                        </div>
                        <div className="ContactSectionContactsRow columns is-mobile is-multiline">

                            <div className="ContactSectionContactItem column">
                                <div className="ContactSectionContactItemWrapper columns is-mobile">
                                    <div className="ContactSectionContactIcon DocumentIcon  column is-narrow" />
                                    <div className="ContactSectionContactItemContentWrapper column">
                                        <div className="ContactItemTopRow">{this.state.ooo}</div>
                                        <div className="ContactItemBottomRow">{`№ лицензии ${this.state.licence}`}</div>
                                    </div>
                                </div>
                            </div>
                            <div className="ContactSectionContactItem column">
                                <div className="ContactSectionContactItemWrapper columns is-mobile">
                                    <div className="ContactSectionContactIcon PhoneIcon column is-narrow" />
                                    <div className="ContactSectionContactItemContentWrapper column ">
                                        <div className="ContactItemTopRow">{`E-mail: ${this.state.email}`}</div>
                                        <div className="ContactItemBottomRow">{this.state.smallPhone}</div>
                                    </div>
                                </div>
                            </div>
                            <div className="ContactSectionContactItem column">
                                <div className="ContactSectionContactItemWrapper columns is-mobile">
                                    <div className="ContactSectionContactIcon PinIcon column is-narrow" />
                                    <div className="ContactSectionContactItemContentWrapper column">
                                        <div className="ContactItemTopRow">{`Адрес: ${this.state.city}, ${this.state.postalcode},`}</div>
                                        <div className="ContactItemBottomRow">{`${this.state.street}, д. ${this.state.building}, офис ${this.state.office}`}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {isMobile.phone ? (
                            <a href={`tel:${this.state.mainPhone}`} className="ContactSectionHugePhoneWrapper u-scalable-1">
                                {this.state.mainPhone}
                            </a>
                        ) : (
                            <div className="ContactSectionHugePhoneWrapper u-scalable-1">
                                {this.state.mainPhone}
                            </div>
                        )}


                    </div>

                </div>
                <div className="MapWrapper  column is-12 is-gapless">
                    {this.state.position ? (
                        <Map
                            center={this.state.position.geometry}
                            zoom={10}
                            scrollWheelZoom={false}
                            dragging={!isMobile.phone}
                        >
                            <TileLayer
                                url='https://tilessputnik.ru/{z}/{x}/{y}.png' //'http://{s}.tile.osm.org/{z}/{x}/{y}.png'
                                attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
                            />
                            <Marker position={this.state.position.geometry} icon={IconMap}>
                                <Popup className={'MainMapPopup'}>
                                    <span>
                                        <span className={'PopupTitleMain'}>{this.state.ooo}</span><br />
                                        <span className={'PopupDescrMain'}>{`${this.state.street}, д. ${this.state.building}, офис ${this.state.office}`}</span>
                                    </span>
                                </Popup>
                            </Marker>
                            {this._renderObjects()}
                        </Map>
                    ) : null}
                </div>
            </div>
        )
    }
}

export default ContactSection


// WEBPACK FOOTER //
// ./src/Components/Sections/ContactSection.js